import React from 'react';
import { Toaster } from 'react-hot-toast';
import { useLocation } from 'react-router-dom';

import { Spinner } from '../components/Spinner';
import { useGetAllTeams } from '../hooks/useGetAllTeams';

import { Sidebar } from './Sidebar/container';

interface LayoutProps {
  children: React.ReactNode;
}

function Layout({ children }: LayoutProps): JSX.Element {
  const location = useLocation();
  const isPublicRoute = ['/login', '/auth/google/callback'].includes(
    location.pathname,
  );
  const { data: teams, isLoading: isLoadingTeams, error } = useGetAllTeams();
  if (isLoadingTeams) {
    return (
      <div className="h-screen w-full flex items-center justify-center">
        <Spinner />
      </div>
    );
  }
  if (error) {
    return <div>Error fetching data</div>;
  }
  return (
    <div className="h-screen min-h-screen flex flex-row w-full overflow-y-hidden">
      <Toaster position="top-right" />
      {/* Sidebar for protected routes only */}
      {!isPublicRoute && <Sidebar teams={teams || []} />}

      <div className="py-8 px-16 bg-[#FEFDFC] w-full overflow-x-auto">
        {children}
      </div>
    </div>
  );
}

export default Layout;
